import { getTableName, TextChangeColor, TextDefaultColor, TextDisabledColor, TextConflictComparisonColor, BGDefaultColor, BGChangeColor, BGDisabledColor, BGErrorColor, BGConditionalColor, BGConflictComparisonColor } from "./table";
import { LOCAL_CONSTANT } from "../page/Const";
import { setTablePhysicsName, pageToTableMapFunc } from "../page/Common";

//文字色判定
export const changeTextColor = (isUserType: boolean, objRrBranchLog: any, pageName: string, labelName: string) => {
    let changeColor = false;
    changeColor = textColor(objRrBranchLog, pageName, labelName);
    // BQにログが存在すれば青文字に変更
    if (changeColor) {
        return TextChangeColor;
    } else {
        // BQにログが存在せず非活性の場合はグレー文字に変更
        // 非活性がtrue 活性がfalse
        if (isUserType) {
            return TextDisabledColor;
            // BQにログが存在せず活性の場合は黒文字に変更
        } else {
            return TextDefaultColor;
        }
    }
};

// 最終更新が992002の場合テキストカラーの変更
export const textColor = (objRrBranchLog: any, pageName: string, labelName: string) => {
    let changeColor = false;
    if (Object.keys(objRrBranchLog).length > 0) {
        const [tableName, columnName, update_department] = checkLogPage(pageName, labelName);
        if (objRrBranchLog[tableName]) {
            objRrBranchLog[tableName].map((row: any) => {
                if (row.target_column === columnName && update_department.includes(row.update_department)) {
                    changeColor = true;
                }
            });
        }
    }
    return changeColor;
};

// 商圏
// 背景色判定 テキストフィールド
export const changeTradeAreaColor = (isUserType: boolean, objRrBranchLog: any, pageName: string, labelName: string, rowIndex: string, seqLabel: string) => {
    let changeColor = false;
    changeColor = tradeAreaTextColor(objRrBranchLog, pageName, labelName, rowIndex, seqLabel);
    // BQにログが存在すれば青文字に変更
    if (changeColor) {
        return TextChangeColor;
    } else {
        // BQにログが存在せず非活性の場合はグレー文字に変更
        // 非活性がtrue 活性がfalse
        if (isUserType) {
            return TextDisabledColor;
            // BQにログが存在せず活性の場合は黒文字に変更
        } else {
            return TextDefaultColor;
        }
    }
};

// 商圏
// 最終更新が992002の場合テキストカラーの変更
export const tradeAreaTextColor = (objRrBranchLog: any, pageName: string, labelName: string, rowIndex: string, seqLabel: string) => {
    let changeColor = false;
    if (Object.keys(objRrBranchLog).length > 0) {
        const [tableName, columnName, update_department] = checkLogPage(pageName, labelName);
        if (objRrBranchLog[tableName]) {
            objRrBranchLog[tableName].map((row: any) => {
                if (row.target_column === columnName) {
                    // sub_keyは「trade_area_seq」、「town_district」あるが「trade_area_seq」の項目がある場合
                    if (row.sub_key.includes("trade_area_seq")) {
                        const subKey = JSON.parse(row.sub_key.includes("'") ? JSON.stringify(row.sub_key).replaceAll('"', "").replaceAll("'", '"') : row.sub_key);
                        if (subKey[seqLabel] === rowIndex && update_department.includes(row.update_department)) {
                            changeColor = true;
                        }
                    }
                }
            });
        }
    }

    return changeColor;
};

// S店(セットバック、立地調査)の出店条件の一部入力欄グレーアウト化
// 地域区分、環境区分、最寄り既設店までの距離
export const changeStoreOpeningConditionsBGColor = (isUserType: boolean, errorList: any, pageName: string, labelName: string, value: any) => {
    let hasError = false;
    // 対象ページを指定
    const targetErrorList = errorList.filter((error:any) => error.page === getTableName(pageName));
    // 入力チェックエラーあり
    if (targetErrorList.length > 0) {
        hasError = targetErrorList.some((error:any) => error.column === labelName);
        if (hasError) return BGErrorColor;
    }
    // S店の出店条件の一部入力欄グレーアウト化
    if(
        labelName === "area_type" || //地域区分
        labelName === "environment_type" || //環境区分
        labelName === "acquisition_requirement" //最寄り既設店までの距離
    ) {
        return BGDisabledColor;
    }
    // 入力チェックエラーなし
    if (isUserType) {
        return BGDisabledColor;
    } else if (value.toString().length > 0) {
        return BGChangeColor;
    }
    return BGDefaultColor;
};

// 表紙、出店条件、現況写真、寄付き
// 背景色判定 テキストフィールド、プルダウン sub_keyが｛｝の場合
export const changeNoSubkeyBGColor = (isUserType: boolean, errorList: any, pageName: string, labelName: string, value: any) => {
    let hasError = false;
    // 対象ページを指定
    const targetErrorList = errorList.filter((error:any) => error.page === getTableName(pageName));
    // 入力チェックエラーあり
    if (targetErrorList.length > 0) {
        hasError = targetErrorList.some((error:any) => error.column === labelName);
        if (hasError) return BGErrorColor;
    }
    // 入力チェックエラーなし
    if (isUserType) {
        return BGDisabledColor;
    } else if (value.toString().length > 0) {
        return BGChangeColor;
    }
    return BGDefaultColor;
};

// 通行量その他
// 非必須項目の背景色　権限判定で非活性の場合は灰色に変更
export const noRequiredBGColor = (isUserType: boolean) => {
    if (isUserType) { return BGDisabledColor; }
    return BGChangeColor;
};

// 表紙
// 背景色判定 チェックボックス sub_keyが｛｝の場合
export const changeNoSubkeyCheckBoxBGColor = (isUserType: boolean, errorList: any, pageName: string, labelName: string, value: boolean) => {
    let hasError = false;
    // 入力チェックあり
    if (errorList.length > 0) {
        hasError = errorList.some(
            (error:any) => error.page === getTableName(pageName) && error.column === labelName
        );
        if (hasError) return BGErrorColor;
    }
    if (isUserType) {
        return BGDisabledColor;
    } else if (value) {
        return BGChangeColor;
    }
    return BGDefaultColor;
};

// 出店条件
// 背景色判定 テキストフィールド、プルダウン
export const changeBGColor = (isUserType: boolean, value: any) => {
    if (isUserType) {
        return BGDisabledColor;
    } else if (value.toString().length > 0) {
        return BGChangeColor;
    }
    return BGDefaultColor;
};

// 出店条件
// 背景色判定 チェックボックス
export const changeCheckBoxBGColor = (isUserType: boolean, value: boolean) => {
    if (isUserType) {
        return BGDisabledColor;
    } else if (value) {
        return BGChangeColor;
    }
    return BGDefaultColor;
};

// 通行量 車通行量、人通行量
export const changeTrafficTableTextColor = (isUserType: boolean, objRrBranchLog: any, pageName: string, labelName: string, subKeyTrafficType: string, subKeyTrafficTypeSeq: string) => {
    let changeColor = false;
    changeColor = trafficTableTextColor(objRrBranchLog, pageName, labelName, subKeyTrafficType, subKeyTrafficTypeSeq);
    // BQにログが存在すれば青文字に変更
    if (changeColor) {
        return TextChangeColor;
    } else {
        // BQにログが存在せず非活性の場合はグレー文字に変更
        // 非活性がtrue 活性がfalse
        if (isUserType) {
            return TextDisabledColor;
            // BQにログが存在せず活性の場合は黒文字に変更
        } else {
            return TextDefaultColor;
        }
    }
};

// 通行量 人通行量（5m内外 合算） 
export const changeTrafficSumTextColor = (objRrBranchLog: any, pageName: string, labelName: string, subKeyTrafficType: string, subKeyTrafficTypeSeq: string) => {
    let changeColor = false;
    changeColor = trafficTableTextColor(objRrBranchLog, pageName, labelName, subKeyTrafficType, subKeyTrafficTypeSeq);
    return changeColor
};

// 通行量 車通行量、人通行量
// 最終更新が992002の場合テキストカラーの変更
export const trafficTableTextColor = (objRrBranchLog: any, pageName: string, labelName: string, subKeytrafficType: string, subKeyTrafficTypeSeq: string
) => {
    let changeColor = false;
    if (Object.keys(objRrBranchLog).length > 0) {
        const [tableName, columnName, update_department] = checkLogPage(pageName, labelName);
        if (objRrBranchLog[tableName]) {
            objRrBranchLog[tableName].map((row: any) => {
                if (row.target_column === columnName) {
                    //sub_keyに「traffic_type」と「traffic_type_seq」の項目がある場合
                    if (row.sub_key.includes("traffic_type") && row.sub_key.includes("traffic_type_seq")) {
                        // シングルクォーテーションをタブルクォーテーション変更してパース
                        const subKey = JSON.parse(row.sub_key.includes("'") ? JSON.stringify(row.sub_key).replaceAll('"', "").replaceAll("'", '"') : row.sub_key);
                        if (subKey.traffic_type === subKeytrafficType && subKey.traffic_type_seq === subKeyTrafficTypeSeq && update_department.includes(row.update_department)) {
                            changeColor = true;
                        }
                    }
                }
            });
        }
    }
    return changeColor;
};

// 通行量 車通行量
// 背景色判定 テキストフィールド sub_keyありの場合
export const changeTrafficCarBGColor = (isUserType: boolean, errorList: any, pageName: string, labelName: string, subKeyTrafficType: string, subKeyTrafficTypeSeq: string, value: any) => {
    let hasError = false;
    // 対象ページと項目名を指定
    const targetErrorList = errorList.filter((error:any) => error.page === getTableName(pageName) && error.column === labelName);
    // 入力チェックエラーあり
    if (targetErrorList.length > 0) {
        targetErrorList.map((row: any) => {
            if (row.sub_key.includes("traffic_type") && row.sub_key.includes("traffic_type_seq")) {
                const subKey = JSON.parse(row.sub_key);
                if (subKey.traffic_type === subKeyTrafficType && subKey.traffic_type_seq === subKeyTrafficTypeSeq) {
                    hasError = true;
                }
            }
        });
        if (hasError) return BGErrorColor;
    }

    // labelNameから対応するキーワードをマッピング（新形式のエラーに対応）
    const labelToKeywordMap: { [key: string]: string } = {
        'car_front_total': '前面',
        'car_side_a_total': '側-A',
        'car_side_b_total': '側-B',
        'car_back_total': '裏道',
    };

    const keyword = labelToKeywordMap[labelName];

    // 新形式のエラー（"車通行量 朝 9:00 ～ 10:00 1行目 側-B"のような形式）に対応
    if (!hasError && keyword) {
        const targetErrorListByKeyword = errorList.filter((error:any) => error.page === getTableName(pageName) && error.column.includes(keyword));
        if (targetErrorListByKeyword.length > 0) {
            targetErrorListByKeyword.map((row: any) => {
                if (row.sub_key.includes("traffic_type") && row.sub_key.includes("traffic_type_seq")) {
                    const subKey = JSON.parse(row.sub_key);
                    if (subKey.traffic_type === subKeyTrafficType && subKey.traffic_type_seq === subKeyTrafficTypeSeq) {
                        hasError = true;
                    }
                }
            });
            if (hasError) return BGErrorColor;
        }
    }

    // 入力チェックエラーなし
    if (isUserType) {
        return BGDisabledColor;
    } else if (value.toString().length > 0) {
        return BGChangeColor;
    }
    return BGDefaultColor;
};

// 通行量 人通行量
// 背景色判定 テキストフィールド sub_keyありの場合
export const changeTrafficPeopleBGColor = (isUserType: boolean, errorList: any, pageName: string, labelName: string, subKeyTrafficType: string, subKeyTrafficTypeSeq: string, value: any, target: string) => {
    let hasError = false;
    // 5m内外合算の背景は変更しない
    if (target.includes(LOCAL_CONSTANT.VALUE.PEOPLE_TARGET_IN_N_OUT)) return BGDisabledColor;
    // 5m外の調査時間と調査日の背景は変更しない
    if (target.includes(LOCAL_CONSTANT.VALUE.PEOPLE_TARGET_OUT) && labelName === "count_date" ||
        target.includes(LOCAL_CONSTANT.VALUE.PEOPLE_TARGET_OUT) && labelName === "count_time"
    ) {
        return BGDisabledColor;
    }

    // 対象ページと項目名を指定
    const targetErrorList = errorList.filter((error:any) => error.page === getTableName(pageName) && error.column === labelName);

    // 入力チェックエラーあり
    if (targetErrorList.length > 0) {
        targetErrorList.map((row: any) => {
            if (row.sub_key.includes("traffic_type") && row.sub_key.includes("traffic_type_seq")) {
                const subKey = JSON.parse(row.sub_key);
                if (subKey.traffic_type === subKeyTrafficType && subKey.traffic_type_seq === subKeyTrafficTypeSeq) {
                    hasError = true;
                }
            }
        });
        if (hasError) return BGErrorColor;
    }
    // 入力チェックエラーなし
    if (isUserType) {
        return BGDisabledColor;
    } else if (value.toString().length > 0) {
        return BGChangeColor;
    }
    return BGDefaultColor;
}

// 競合店 
// 彼我比較判定
const conflictStoreComparison = (labelName: string, type: string, ownStore: any,  conflictData: any) => {
    //比較対象項目リスト
    const targetCol = [
        "sales_floor_area_size", //売場面積(㎡)
        "gondola_scale",         //ゴンドラ尺数
        "store_frontage",        //店舗間口
        "parking_area_size",     //駐車場面積(㎡)
        "number_of_parking",     //駐車場台数
        "front_parking_tangent", //前面駐車場接線(m)
        "front_first_entrance",  //前面第一進入口(m)
        "front_first_depth",     //前面第一奥行き(m)
        "front_second_entrance", //前面第二進入口(m)
        "front_second_depth",    //前面第二奥行き(m)
        "side_parking_tangent",  //側道(裏道)駐車場接線(m)
        "side_first_entrance",   //側道(裏道)第一進入口(m)
        "side_first_depth",      //側道(裏道)第一奥行き(m)
        "side_second_entrance",  //側道第二進入口(m)
        "side_second_depth",     //側道第二奥行き(m)
    ];
    //対象の項目かつCVSのみ
    if(targetCol.includes(labelName) && type === "cvs-master-data")
        {
            const ownStoreValue = Number(ownStore[labelName] ?? 0);
            const conflictStoreValue = Number(conflictData[labelName] ?? 0);
            if (conflictStoreValue > ownStoreValue) {
                return true;
            }
        }
    return false;
}

// 競合
export const changeConflictTextColor = (objRrBranchLog: any, pageName: string, labelName: string, type?: string, ownStore?: any, conflictData?: any) => {
    let changeColor = false;
    if(conflictData) {
        changeColor = conflictTextColor(objRrBranchLog, pageName, labelName, conflictData["conflict_type"], conflictData["conflict_sequence"]);
    }
    // BQにログが存在すれば青文字に変更
    if (changeColor) {
        return TextChangeColor;
    // BQにログが存在せず、競合店＞自店の場合は白文字に変更
    } else if (type && ownStore && conflictData && conflictStoreComparison(labelName, type, ownStore, conflictData)) {
        return TextConflictComparisonColor;
    // BQにログが存在しない場合は黒文字に変更
    } else {
        return TextDefaultColor;
    }
};

// 競合
// 最終更新が992002の場合テキストカラーの変更
export const conflictTextColor = (objRrBranchLog: any, pageName: string, labelName: string, subKeyConflictType: string, subKeyConflictSequence: string
) => {
    let changeColor = false;
    if (Object.keys(objRrBranchLog).length > 0) {
        const [tableName, columnName, update_department] = checkLogPage(pageName, labelName);
        if (objRrBranchLog[tableName]) {
            objRrBranchLog[tableName].map((row: any) => {
                if (row.target_column === columnName) {
                    //sub_keyに「traffic_type」と「traffic_type_seq」の項目がある場合
                    if (row.sub_key.includes("conflict_type") && row.sub_key.includes("conflict_sequence")) {
                        // シングルクォーテーションをタブルクォーテーション変更してパース
                        const subKey = JSON.parse(row.sub_key.includes("'") ? JSON.stringify(row.sub_key).replaceAll('"', "").replaceAll("'", '"') : row.sub_key);
                        if (subKey.conflict_type === subKeyConflictType && subKey.conflict_sequence === subKeyConflictSequence && update_department.includes(row.update_department)) {
                            changeColor = true;
                        }
                    }
                }
            });
        }
    }
    return changeColor;
};

// 競合
// 背景色判定 テキストフィールド、プルダウン sub_keyありの場合
export const changeConflictBGColor = (isUserType: boolean, errorList: any, pageName: string, labelName: string, type: string, ownStore: any, conflictData: any, editFlag: boolean) => {
    let hasError = false;
    // 対象ページを指定
    const targetErrorList = errorList.filter((error:any) => error.page === getTableName(pageName) && error.column === labelName);
    // 入力チェックエラーあり
    if (targetErrorList.length > 0) {
        targetErrorList.map((row: any) => {
            if (row.sub_key.includes("conflict_type") && row.sub_key.includes("conflict_sequence")) {
                const subKey = JSON.parse(row.sub_key);
                if (subKey.conflict_type === conflictData["conflict_type"] && subKey.conflict_sequence ===  conflictData["conflict_sequence"]) {
                    hasError = true;
                }
            }
        });
        if (hasError) return BGErrorColor;
    }

    // 入力チェックエラーなし
    // 自店と競合店を判定(競合店>自店ならば赤背景、白文字)
    if (conflictStoreComparison(labelName, type, ownStore, conflictData)) {
        // 通常時
        if (!editFlag) {
            return BGConflictComparisonColor;
        // 編集時(活性化時)
        } else if (editFlag && !isUserType) {
            return BGConflictComparisonColor;
        // 編集時(非活性時)
        } else {
            return BGDisabledColor;
        }
    // 商圏カットは水色背景に変更
    } else if (conflictData["market_cut"] === "1") {
        // 通常時
        if (!editFlag) {
            return BGConditionalColor;
        // 編集時(活性化時)
        } else if (editFlag && !isUserType) {
            return BGConditionalColor;
        // 編集時(非活性時)
        } else {
            return BGDisabledColor;
        }
    // 非活性判定
    } else if (isUserType) {
        return BGDisabledColor;
    // 活性化かつ入力値がある場合
    } else if (conflictData[labelName].toString().length > 0) {
        return BGChangeColor;
    }
    return BGDefaultColor;
};

// 影響度
export const changeImpactTextColor = (isUserType: boolean, objRrBranchLog: any, pageName: string, labelName: string, subKeyStoreCode: string, subKeyTenpoName: string) => {
    let changeColor = false;
    changeColor = impactTextColor(objRrBranchLog, pageName, labelName, subKeyStoreCode, subKeyTenpoName);
    // BQにログが存在すれば青文字に変更
    if (changeColor) {
        return TextChangeColor;
    } else {
        // BQにログが存在せず非活性の場合はグレー文字に変更
        // 非活性がtrue 活性がfalse
        if (isUserType) {
            return TextDisabledColor;
            // BQにログが存在せず活性の場合は黒文字に変更
        } else {
            return TextDefaultColor;
        }
    }
};

// 影響度
// 最終更新が992002の場合テキストカラーの変更
export const impactTextColor = (objRrBranchLog: any, pageName: string, labelName: string, subKeyStoreCode: string, subKeyTenpoName: string) => {
    let changeColor = false;
    if (Object.keys(objRrBranchLog).length > 0) {
        const [tableName, columnName, update_department] = checkLogPage(pageName, labelName);
        if (objRrBranchLog[tableName]) {
            objRrBranchLog[tableName].map((row: any) => {
                if (row.target_column === columnName) {
                    //sub_keyに「store_code」と「tenpo_name」の項目がある場合
                    if (row.sub_key.includes("store_code") && row.sub_key.includes("tenpo_name")) {
                        // シングルクォーテーションをタブルクォーテーション変更してパース
                        const subKey = JSON.parse(row.sub_key.includes("'") ? JSON.stringify(row.sub_key).replaceAll('"', "").replaceAll("'", '"') : row.sub_key);
                        if (subKey.store_code === subKeyStoreCode && subKey.tenpo_name === subKeyTenpoName && update_department.includes(row.update_department)) {
                            changeColor = true;
                        }
                    }
                }
            });
        }
    }

    return changeColor;
};

// 影響度
// 背景色判定 テキストフィールド、プルダウン sub_keyありの場合
export const changeImpactBGColor = (isUserType: boolean, errorList: any, pageName: string, labelName: string, subKeyStoreCode: string, subKeyTenpoName: string, value: any) => {
    let hasError = false;
    // 対象ページを指定
    const targetErrorList = errorList.filter((error:any) => error.page === getTableName(pageName) && error.column === labelName);
    // 入力チェックエラーあり
    if (targetErrorList.length > 0) {
        targetErrorList.map((row: any) => {
            if (row.sub_key.includes("store_code") && row.sub_key.includes("tenpo_name")) {
                const subKey = JSON.parse(row.sub_key);
                if (subKey.store_code === subKeyStoreCode && subKey.tenpo_name === subKeyTenpoName) {
                    hasError = true;
                }
            }
        });
        if (hasError) return BGErrorColor;
    }
    // 入力チェックエラーなし
    if (isUserType) {
        return BGDisabledColor;
    } else if (value.toString().length > 0) {
        return BGChangeColor;
    }
    return BGDefaultColor;
};

//図面
//文字色判定
export const changeDrawingTextColor = (isUserType: boolean, objRrBranchLog: any, pageName: string, labelName: string, rowIndex: number, seqLabel: string) => {
    let changeColor = false;
    changeColor = DrawingTextColor(objRrBranchLog, pageName, labelName, rowIndex, seqLabel);
    // BQにログが存在すれば青文字に変更
    if (changeColor) {
        return TextChangeColor;
    } else {
        // BQにログが存在せず非活性の場合はグレー文字に変更
        // 非活性がtrue 活性がfalse
        if (isUserType) {
            return TextDisabledColor;
            // BQにログが存在せず活性の場合は黒文字に変更
        } else {
            return TextDefaultColor;
        }
    }
};

// 図面
// 最終更新が992002の場合テキストカラーの変更
export const DrawingTextColor = (objRrBranchLog: any, pageName: string, labelName: string, rowIndex: number, seqLabel: string) => {
    let changeColor = false;
    if (Object.keys(objRrBranchLog).length > 0) {
        const [tableName, columnName, update_department] = checkLogPage(pageName, labelName);
        if (objRrBranchLog[tableName]) {
            let logBefoerValueList: any = [];
            let logAfterValueList: any = [];
            objRrBranchLog[tableName].map((row: any) => {
                if (row.target_column === columnName) {
                    if (row.target_column === "hand_drawn_layout" && row.target_before_value.includes("{")) {
                        const logBefoerValue = JSON.parse(row.target_before_value);
                        logBefoerValueList.push(logBefoerValue);
                    }
                    if (row.target_column === "hand_drawn_layout" && row.target_after_value.includes("{")) {
                        const logAfterValue = JSON.parse(row.target_after_value);
                        logAfterValueList.push(logAfterValue);
                    }
                    if (process.env.REACT_APP_MODE === "local" || process.env.REACT_APP_MODE === "dev") {
                        if (
                            logBefoerValueList[0]?.[rowIndex]?.[seqLabel] != logAfterValueList[0]?.[rowIndex]?.[seqLabel] &&
                            (LOCAL_CONSTANT.RR_DEPARTMENT.includes(row.update_department) || row.update_department === "950404")
                        ) {
                            changeColor = true;
                        }
                    } else {
                    }
                    if (logBefoerValueList[0]?.[rowIndex]?.[seqLabel] != logAfterValueList[0]?.[rowIndex]?.[seqLabel] && update_department.includes(row.update_department)) {
                        changeColor = true;
                    }

                    //配列リセット
                    logBefoerValueList.shift();
                    logAfterValueList.shift();
                }
            });
        }
    }
    return changeColor;
};

//不備コメントの項目が登録されている場合、trueを返す borderColorを赤に変更
export const changeBorderColor = (listDeficiencyComment: any, pageName: string, labelName: string) => {
    let hasError = false;

    if (listDeficiencyComment.length === 0) {
        return hasError;
    }

    const pageToTableMap = pageToTableMapFunc(pageName);

    hasError = listDeficiencyComment.some(
        (deficiencyComment: any) =>
            deficiencyComment.table_name === setTablePhysicsName(pageToTableMap) &&
            deficiencyComment.column_name === labelName &&
            LOCAL_CONSTANT.DEFICIENCY.STATUS.includes(deficiencyComment.deficiency_status)
        );

    return hasError;
};

//影響度
//不備コメントの項目が登録されている場合、trueを返す borderColorを赤に変更
export const changeBorderImpactColor = (
    listDeficiencyComment: any,
    pageName: string,
    labelName: string,
    subKeyStoreCode: string,
    subKeyTenpoName: string
) => {
    let hasError = false;

    if (listDeficiencyComment.length === 0) {
        return hasError;
    }

    hasError = listDeficiencyComment.some((deficiencyComment: any) => {
        if (deficiencyComment.sub_key.includes("store_code") && deficiencyComment.sub_key.includes("tenpo_name")) {
            const parsed_sub_key = JSON.parse(deficiencyComment.sub_key);
            return (
                deficiencyComment.table_name === LOCAL_CONSTANT.TABLE.IMPACT &&
                deficiencyComment.column_name === labelName &&
                parsed_sub_key.store_code === subKeyStoreCode &&
                parsed_sub_key.tenpo_name === subKeyTenpoName &&
                LOCAL_CONSTANT.DEFICIENCY.STATUS.includes(deficiencyComment.deficiency_status)
            )
        } else {
            return false;
        }
    });

    return hasError;
};

//影響度 交差点
//不備コメントの項目が登録されている場合、trueを返す borderColorを赤に変更
export const changeBorderImpactIntersectionColor = (
    listDeficiencyComment: any,
    labelName: string,
    subKey: string,
) => {
    let hasError = false;

    if (listDeficiencyComment.length === 0) {
        return hasError;
    }

    hasError = listDeficiencyComment.some((deficiencyComment: any) => {
        if (deficiencyComment.sub_key.includes("route_seq") &&
            deficiencyComment.sub_key.includes("counter_uuid") &&
            deficiencyComment.sub_key.includes("tenpo_name") &&
            deficiencyComment.sub_key.includes("route") &&
            deficiencyComment.sub_key.includes("intersection")
        ) {
            const parsed_sub_key = JSON.parse(deficiencyComment.sub_key);
            const parsedSubKey = JSON.parse(subKey);
            return (
                deficiencyComment.table_name === LOCAL_CONSTANT.TABLE.IMPACT &&
                deficiencyComment.column_name === labelName &&
                parsed_sub_key.route_seq === parsedSubKey.routeSeq &&
                parsed_sub_key.counter_uuid === parsedSubKey.counterUuid &&
                parsed_sub_key.tenpo_name === parsedSubKey.tenpoName &&
                parsed_sub_key.route === parsedSubKey.route &&
                parsed_sub_key.intersection === parsedSubKey.intersection &&
                LOCAL_CONSTANT.DEFICIENCY.STATUS.includes(deficiencyComment.deficiency_status)
            )
        } else {
            return false;
        }
    });

    return hasError;
};

const init_update_department = () => {
    let update_department = LOCAL_CONSTANT.RR_DEPARTMENT;
    if (process.env.REACT_APP_MODE === "local" || process.env.REACT_APP_MODE === "dev") {
        update_department.push("950404");
    }

    return update_department;
};

const checkLogPage = (pageName: string, labelName: string) => {
    const tableName = getTableName(pageName);
    const update_department = init_update_department();

    return [tableName, labelName, update_department];
};
